// ======================================================================
// File Name       : archivement
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_RECEIVE_USER_LIST = 'USER_RECEIVE_USER_LIST';
export const USER_RECEIVE_AUTHORITY_LIST = 'USER_RECEIVE_AUTHORITY_LIST';
export const USER_RECEIVE_REPORT_OPERATION_COUNT = 'USER_RECEIVE_REPORT_OPERATION_COUNT';
export const USER_RECEIVE_REPORT_OPERATION_LIST = 'USER_RECEIVE_REPORT_OPERATION_LIST';
export const USER_RECEIVE_MAPPING_USER = 'USER_RECEIVE_MAPPING_USER';
